export default __webpack_public_path__ + "static/media/stage1-lvl1 1.a83759b7.png";